import React, { memo, useEffect, useState } from "react";
import Form from "../../../Components/Form";
import ConstraintTable from "../../../Tables/OptionGreek/Constraint/ConstraintTable";
import {
  IOptionGreekConstraintFormValues,
  IOptionsGreekConstraintTableReport,
} from "../../../Interfaces/optionGreek";
import { useAppDispatch, useAppSelector } from "../../../App/hooks";
import {
  optionGreekConstraintFormValuesChangeHandler,
  setOptionGreekConstraintFormValues,
  setOptionGreekConstraintTableFlag,
} from "../../../Features/OptionGreek/optionGreekSlice";
import {
  getRiskFreeRate,
  setServerRiskFreeRate,
  upsertOptionGreekConstraint,
} from "../../../Requests/optionGreek";
import { toast } from "react-toastify";
import { packetErrorHandler } from "../../../Utils/requestUtils";
import DynamicDropdown from "../../../Components/Dropdown/DynamicDropdown";
import { getBaseInstruments } from "../../../Requests/Order/tradeTableRequests";
import TextInput from "../../../Components/TextInput";
import Button from "../../../Components/Button";

const ModalUI = memo(() => {
  const formValues = useAppSelector(
    (store) => store.optionGreek.constraintFormValues
  );
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const [riskFreeRate, setRiskFreeRate] = useState("");

  useEffect(() => {
    getRiskFreeRate()
      .then((resp) => {
        setRiskFreeRate(resp.riskFreeRate.toString() || "");
      })
      .catch(packetErrorHandler);
  }, []);

  const changeHandler = (name: string, value: any) => {
    dispatch(optionGreekConstraintFormValuesChangeHandler({ name, value }));
  };

  const checkDisabled = () => {
    if (!formValues) return true;
    if (
      !formValues.baseInsId ||
      (!formValues.dividendYield && formValues.dividendYield !== 0) ||
      (!formValues.volatilityBaseIns && formValues.volatilityBaseIns !== 0)
    )
      return true;
    return false;
  };

  const clickHandler = () => {
    setLoading(true);
    upsertOptionGreekConstraint(formValues)
      .then((resp) => {
        toast.success(resp.msg);
        dispatch(setOptionGreekConstraintTableFlag(true));
        dispatch(
          setOptionGreekConstraintFormValues(
            {} as IOptionGreekConstraintFormValues
          )
        );
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  const tableRowClickHandler = (row: IOptionsGreekConstraintTableReport) => {
    dispatch(
      setOptionGreekConstraintFormValues({
        baseInsId: row.instrumentId,
        dividendYield: parseFloat(row.dividendYield),
        id: row.id,
        volatilityBaseIns: parseFloat(row.volatilityBaseIns),
      })
    );
  };

  const setRiskFreeRateHandler = () => {
    setServerRiskFreeRate(riskFreeRate)
      .then((resp) => {
        if (resp.data) toast.success(resp.msg);
        else toast.error(resp.msg);
      })
      .catch(packetErrorHandler);
  };

  return (
    <div className="flex flex-row justify-start items-start gap-10">
      <Form className="p-3 gap-3 !w-60">
        <div className="flex flex-row justify-start items-end gap-5">
          <TextInput
            label="نرخ بهره"
            name=""
            onChange={(_, v) => setRiskFreeRate(v)}
            value={riskFreeRate}
            extraLabel
          />
          <Button
            text="اعمال"
            variant="contained"
            onClick={setRiskFreeRateHandler}
            className="!h-8 !w-8"
          />
        </div>

        <DynamicDropdown
          dropdown={{
            name: "baseInsId",
            placeholder: "نماد پایه",
            extraLabel: true,
          }}
          onChange={changeHandler}
          getData={() => getBaseInstruments()}
          value={formValues.baseInsId}
        />
        <TextInput
          label="نوسان پذیری"
          value={formValues.volatilityBaseIns?.toString()}
          name="volatilityBaseIns"
          onChange={changeHandler}
          kind="priceWithDecimal"
          extraLabel
        />
        <TextInput
          label="سود نقدی"
          value={formValues.dividendYield?.toString()}
          name="dividendYield"
          onChange={changeHandler}
          kind="priceWithDecimal"
          extraLabel
        />

        <Button
          onClick={clickHandler}
          text="ثبت"
          variant="contained"
          disabled={checkDisabled()}
          loading={loading}
        />
      </Form>
      <ConstraintTable onTableRowClick={tableRowClickHandler} />
    </div>
  );
});

export default ModalUI;
